export default __webpack_public_path__ + "static/media/qr-shb.478df419.png";